"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromiseLimiter = void 0;
const pLimit = require("p-limit");
const DEFAULT_CONCURRENCY = 10;
class PromiseLimiter {
    static executeFunctions(functions, concurrency = DEFAULT_CONCURRENCY) {
        const limit = pLimit(concurrency);
        const input = functions.map((f) => limit(f));
        return input;
    }
    constructor(concurrency = DEFAULT_CONCURRENCY) {
        this.limiter = pLimit(concurrency);
    }
    async limit(fn, ...args) {
        return this.limiter(fn, ...args);
    }
}
exports.PromiseLimiter = PromiseLimiter;
exports.default = PromiseLimiter;
//# sourceMappingURL=PromiseLimiter.js.map